import { AimOutlined, ClockCircleOutlined } from "@ant-design/icons";
import React, { useState } from "react";

import "./stylesScheduleDelivery.css";
import { Checkbox, Select } from "antd";

function ScheduleDelivery() {
  const [activeScheduler, setActiveScheduler] = useState(0);
  const [activeSchedulingOption, setActiveSchedulingOption] = useState(0);

  return (
    <div className="schedule-delivery-container">
      <div className="schedule-delivery-header">
        <h2>Delivery</h2>
        <p>Choose type:</p>
        <div className="schedule-delivery-types">
          <div
            className={`schedule-delivery-type ${
              activeScheduler === 0 ? "active" : ""
            }`}
            onClick={() => setActiveScheduler(0)}
          >
            <div className="schedule-delivery-type-header">
              <div className="clock-icon-container">
                <AimOutlined className="schedule-delivery-icon" />
              </div>
              <div className="circle">
                <div className="inner-circle"></div>
              </div>
            </div>
            <h3>Scheduled</h3>
            <p>
              Enter players at <br />
              designated times
            </p>
          </div>
          <div
            className={`schedule-delivery-type ${
              activeScheduler === 1 ? "active" : ""
            }`}
            onClick={() => setActiveScheduler(1)}
          >
            <div className="schedule-delivery-type-header">
              <div className="clock-icon-container">
                <ClockCircleOutlined className="schedule-delivery-icon" />
              </div>
              <div className="circle">
                <div className="inner-circle"></div>
              </div>
            </div>
            <h3>Action-Based</h3>
            <p>
              Enter player when they <br /> perform actions
            </p>
          </div>
        </div>
      </div>
      <div className="scheduling-options-container">
        <h3>Time-Based Scheduling Options</h3>
        <div className={`scheduling-options`}>
          <div
            className={`scheduling-option-1 ${
              activeSchedulingOption === 0 ? "active" : ""
            }`}
          >
            <div
              className="circle"
              onClick={() => setActiveSchedulingOption(0)}
            >
              <div className="inner-circle"></div>
            </div>
            <span>Send as soon as Promo is launched</span>
          </div>
          <div
            className={`scheduling-option-2 ${
              activeSchedulingOption === 1 ? "active" : ""
            }`}
          >
            <div
              className="circle"
              onClick={() => setActiveSchedulingOption(1)}
            >
              <div className="inner-circle"></div>
            </div>
            <div>
              <span>Send at a designated time</span>
              <p>Choose a time for players to receive this message.</p>
            </div>
          </div>
        </div>
      </div>
      <div className="how-often-container">
        <p>How often to send?</p>
        <div className="how-often-options">
          <Select
            placeholder="Select frequency"
            options={[
              { value: "Once", label: "Once" },
              { value: "Daily", label: "Daily" },
              { value: "Weekly", label: "Weekly" },
              { value: "Monthly", label: "Monthly" },
            ]}
          />
          <div className="checkbox-container">
            <Checkbox defaultChecked={false} onChange={() => {}} />
            <span>Send Promo to players in their local time zone</span>
          </div>
        </div>
        <div className="next-send-time">
          <div className="left-content">
            <ClockCircleOutlined className="schedule-delivery-icon" />
            <span>Next send time:</span>
          </div>
          <span className="next-send-time-text">
            No upcoming messages scheduled.
          </span>
        </div>
        <div className="delivery-controls">
          <h3>Delivery Controls</h3>
          <div className="delivery-controls-options">
            <p>Manage the number of messages your players will receive.</p>
            <div className="checkbox-container">
              <Checkbox defaultChecked={false} onChange={() => {}} />
              <span>Allow players to become re-eligible to receive promo</span>
            </div>
          </div>
          <p className="frequency-capping">Frequency Capping</p>
          <p className="frequency-capping-text">
            You have not created any Frequency Capping rules.{" "}
            <span>Manage frequency capping rules.</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ScheduleDelivery;
